import { IconCheckOutline18 as Check } from "nucleo-ui-outline-18"

import { cn } from "@productlane/lib/src/browser"
import { CommandItem } from "@productlane/ui/src/components/internal/command"

import type { SharedFilterItemsProps } from "./types"
import { IssuePriorityIcon } from "@/screens/app/issues/issue-priority-icon"
import { useRoadmapFilterState } from "../roadmap-filter-state"

export const ROADMAP_PRIORITIES: string[] = [
	"Urgent",
	"High",
	"Medium",
	"Low",
	"No priority",
]

export function PriorityFilterItems({ onSelect }: SharedFilterItemsProps) {
	const {
		priorities: selected,
		addPriority,
		removePriority,
	} = useRoadmapFilterState()

	return (
		<>
			{ROADMAP_PRIORITIES.map((priority) => {
				const isSelected = selected.includes(priority)
				return (
					<CommandItem
						key={priority}
						onSelect={() => {
							if (isSelected) {
								removePriority(priority)
							} else {
								addPriority(priority)
							}
							onSelect()
						}}
					>
						<div className="flex w-full items-center gap-2">
							<IssuePriorityIcon
								priority={priority}
								className="h-4 w-4 shrink-0 text-secondary"
							/>
							<span className="flex-1 truncate">{priority}</span>
							<Check
								className={cn("h-4 w-4 shrink-0", {
									"opacity-100": isSelected,
									"opacity-0": !isSelected,
								})}
							/>
						</div>
					</CommandItem>
				)
			})}
		</>
	)
}
